import moment from "moment";
import React, { useContext, useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../../stylesheets/components/Reports/PandLReports/PnlDownloadPopupMob.scss";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Drawer from "react-bottom-drawer";
import { ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import di from "../di/servicelocator";
import SmcasePopupLoaderMob from "../../HoldingReports/SMCaseLoadPopup/SmcasePopupLoaderMob";
import SmcasePopupFailMob from "../../HoldingReports/SMCaseLoadPopup/SmcasePopupFailMob";
import SmcasePopupSuccessMob from "../../HoldingReports/SMCaseLoadPopup/SmcasePopupSuccessMob";
import { assetTypeMappingObj, TabMapping, } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import { emailRegex } from "../../../../utils/regex";
import { useDispatch, useSelector } from "react-redux";
import { getQueryParameterName } from "../../../../utils/urlHelper";
import { enterMail, validMail } from "@domains/utils/commonText";
import { pnlDownloadDate, previousDay, } from "@domains/utils/reportDates";
import { storeEmailListInSessionStorage } from "@domains/utils/sessionMethods";
import { PNL_HIDE_ERROR } from "@frameworks/web/redux/interfaces/Reports/iPNLReport";
import { PNLErrorEnum } from "@adapters/presenters/action-interfaces/Reports/PNLReport";
import { getLoginSourceURL } from "@frameworks/web/utils/Navigate";
import PANPassword from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/PANPassword";
import { WebConfigContext } from "@frameworks/web/utils/webConfig";
import { ELoginSource } from "@domains/entities/interfaces/iUserDetails";
import { LoginSource } from "@domains/utils/emtReportCallback";
const DownloadReportPopupMob = (props) => {
    const webConfig = useContext(WebConfigContext);
    const navigate = useNavigate();
    const sales_native_app = JSON.parse(localStorage.getItem("sales_native_app"));
    const { loginOrigin } = useParams();
    const location = useLocation();
    const locationState = location.state;
    const fromDate = getQueryParameterName("fromDate");
    const toDate = getQueryParameterName("toDate");
    const duration = getQueryParameterName("duration");
    const assetType = getQueryParameterName("assetType");
    const scripIdentifier = getQueryParameterName("scripIdentifier");
    const accCode = window.atob(getQueryParameterName("family"));
    const [startDate, setStartDate] = useState(new Date(fromDate));
    const [endDate, setEndDate] = useState(new Date(toDate));
    const [isVisibleStart, setIsVisibleStart] = React.useState(false);
    const [isVisibleEnd, setIsVisibleEnd] = React.useState(false);
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const sessionEmailList = sessionStorage.getItem("emailList");
    const inputRef = useRef(null);
    const _startcalendar = useRef(null);
    const _endcalendar = useRef(null);
    const dispatch = useDispatch();
    const startDatePicker = (e) => {
        setIsVisibleStart(true);
        if (_startcalendar.current) {
            _startcalendar.current.setOpen(true);
        }
    };
    const endDatePicker = (e) => {
        setIsVisibleEnd(true);
        if (_endcalendar.current) {
            _endcalendar.current.setOpen(true);
        }
    };
    const closeDrawerDate = () => {
        setIsVisibleStart(false);
        setIsVisibleEnd(false);
    };
    const [emailList, setEmailList] = useState([]);
    const [downloadCheck, setDownloadCheck] = useState(false);
    const [emailCheck, setEmailCheck] = useState(false);
    const [PDF_or_Excel, setPDForExcel] = useState(null);
    const [currEmailvalue, setCurrEmailValue] = useState();
    const emailStatus = useSelector((state) => state.pnlReport.emailStatus);
    const downloadStatus = useSelector((state) => state.pnlReport.downloadStatus);
    const defaultEmailId = useSelector((state) => state.accountDetailsReducer.emaildId);
    const isImpersonated = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.isImpersonated; });
    const lgnSrc = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.lgnSrc; });
    const isClientLogin = loginOrigin !== LoginSource.SALES &&
        !sales_native_app &&
        !isImpersonated &&
        lgnSrc !== ELoginSource.NESTTRADER;
    const FilterData = useSelector((state) => state.pnlReport.data.FilterData);
    const EmailListUpdate = () => {
        if (emailRegex.test(currEmailvalue) &&
            !emailList.includes(currEmailvalue)) {
            storeEmailListInSessionStorage(currEmailvalue, sessionEmailList, true);
            setEmailList([...emailList, currEmailvalue]);
            setCurrEmailValue("");
            return [...emailList, currEmailvalue];
        }
        return [];
    };
    useEffect(() => {
        if (defaultEmailId && !emailList.includes(defaultEmailId)) {
            let defaultEmailList = [defaultEmailId];
            let sessionEmailArray = sessionEmailList && sessionEmailList.split(",").length > 0
                ? sessionEmailList.split(",")
                : [];
            let finalEmailList = defaultEmailList;
            if (sessionEmailArray && sessionEmailArray.length > 0) {
                sessionEmailArray.map((emailId) => {
                    finalEmailList.push(emailId);
                });
            }
            setEmailList(finalEmailList);
        }
        else {
            if (emailList && emailList.length > 0) {
            }
            let sessionEmailArray = sessionEmailList && sessionEmailList.split(",").length > 0
                ? sessionEmailList.split(",")
                : [];
            let finalEmailList = emailList && emailList.length > 0 ? emailList : [];
            if (sessionEmailArray && sessionEmailArray.length > 0) {
                sessionEmailArray.map((emailId) => {
                    if (!emailList.includes(emailId))
                        finalEmailList.push(emailId);
                });
            }
            setEmailList(finalEmailList);
        }
    }, [defaultEmailId, emailCheck]);
    const openDrawerLoader = React.useCallback(() => props.setShowLoader(true), []);
    const openDrawerDownloadS = React.useCallback(() => props.setDownloadSuccess(true), []);
    const openDrawerFail = React.useCallback(() => props.setDownloadFail(true), []);
    const closeDrawerLoader = React.useCallback(() => props.setShowLoader(false), []);
    const closeDrawerDownloadS = React.useCallback(() => props.setDownloadSuccess(false), []);
    const closeDrawerFail = React.useCallback(() => props.setDownloadFail(false), []);
    const goBack = () => {
        dispatch({
            type: PNL_HIDE_ERROR,
            errorType: PNLErrorEnum.DOWNLOADSTATUS,
        });
        dispatch({
            type: PNL_HIDE_ERROR,
            errorType: PNLErrorEnum.EMAILSTATUS,
        });
        const assetTypeObj = Object.entries(assetTypeMappingObj);
        let appendAssetType;
        assetTypeObj.forEach((assetRecord) => {
            var _a;
            if (((_a = assetRecord[1]) === null || _a === void 0 ? void 0 : _a.assetType) === assetType) {
                appendAssetType = assetRecord[0];
            }
        });
        let foundTab;
        TabMapping.map((tabRecord) => {
            var _a;
            if ((tabRecord === null || tabRecord === void 0 ? void 0 : tabRecord.assetType) && ((_a = tabRecord === null || tabRecord === void 0 ? void 0 : tabRecord.assetType) === null || _a === void 0 ? void 0 : _a.length) > 1)
                tabRecord.assetType.map((assetRecord) => {
                    if (assetRecord === assetType)
                        foundTab = tabRecord;
                });
            else if ((tabRecord === null || tabRecord === void 0 ? void 0 : tabRecord.assetType) && tabRecord.assetType[0] === assetType) {
                foundTab = tabRecord;
            }
        });
        const urlParams = new URLSearchParams({
            reportName: "ProfitandLoss",
            tab: foundTab.tabEventKey,
            assetType: appendAssetType,
            fromDate: moment(new Date(fromDate)).format("yyyy-MM-DD"),
            toDate: moment(new Date(toDate)).format("yyyy-MM-DD"),
        });
        // Construct the full destination URL
        const baseUrl = ".." + getLoginSourceURL(loginOrigin);
        const destination = `${baseUrl}?${urlParams.toString()}`;
        navigate(destination, { replace: true });
    };
    let handleSubmit = (e) => {
        var _a, _b, _c, _d, _e, _f;
        e.preventDefault();
        let expiryMonth = (_b = (_a = FilterData.expiryMonth) === null || _a === void 0 ? void 0 : _a.filters) === null || _b === void 0 ? void 0 : _b.filter((filter) => filter.selected).map((x) => moment().month(x.title).format("M"));
        let underlyingAsset = (_d = (_c = FilterData.underlyingAsset) === null || _c === void 0 ? void 0 : _c.filters) === null || _d === void 0 ? void 0 : _d.filter((filter) => filter.selected).map((x) => x.title);
        openDrawerLoader();
        let emailFormat, downloadFormat = undefined;
        if (downloadCheck) {
            downloadFormat = {
                fromDate: moment(startDate).format("yyyy-MM-DD"),
                toDate: moment(endDate).format("yyyy-MM-DD"),
                reportType: PDF_or_Excel,
                assetType: assetType,
                duration: duration,
            };
            if (scripIdentifier)
                downloadFormat.scripIdentifier = scripIdentifier;
            if ((expiryMonth === null || expiryMonth === void 0 ? void 0 : expiryMonth.length) > 0)
                downloadFormat.expiryMonth = expiryMonth.join();
            if ((underlyingAsset === null || underlyingAsset === void 0 ? void 0 : underlyingAsset.length) > 0)
                downloadFormat.underlyingAsset = underlyingAsset.join();
            if ((accCode === null || accCode === void 0 ? void 0 : accCode.length) > 0)
                downloadFormat.accodes = accCode;
            if (((_e = accCode === null || accCode === void 0 ? void 0 : accCode.split(",")) === null || _e === void 0 ? void 0 : _e.length) > 1)
                downloadFormat.isConsolidated = true;
            if (webConfig.passwordProtectedDownloadReports)
                downloadFormat.isPwdProtected = true;
            props.setOperation("download");
        }
        if (emailCheck) {
            let list = emailList;
            if (emailList.length === 0 && currEmailvalue.length > 3) {
                list = EmailListUpdate();
            }
            emailFormat = {
                fromDate: moment(startDate).format("yyyy-MM-DD"),
                toDate: moment(endDate).format("yyyy-MM-DD"),
                reportType: PDF_or_Excel,
                assetType: assetType,
                emailIds: list,
                duration: duration,
            };
            if ((expiryMonth === null || expiryMonth === void 0 ? void 0 : expiryMonth.length) > 0)
                emailFormat.expiryMonth = expiryMonth.join();
            if ((underlyingAsset === null || underlyingAsset === void 0 ? void 0 : underlyingAsset.length) > 0)
                emailFormat.underlyingAsset = underlyingAsset.join();
            if ((accCode === null || accCode === void 0 ? void 0 : accCode.length) > 0)
                emailFormat.accodes = accCode;
            if (((_f = accCode === null || accCode === void 0 ? void 0 : accCode.split(",")) === null || _f === void 0 ? void 0 : _f.length) > 1)
                downloadFormat.isConsolidated = true;
            props.setOperation("email");
        }
        if (downloadCheck && emailCheck) {
            props.setOperation("email_download");
        }
        if (locationState === null || locationState === void 0 ? void 0 : locationState.avoidEmail)
            submitEmailDownload(null, downloadFormat);
        else
            di.pnlReport.downloadAndSendReportPNL(props.tabName, emailFormat, downloadFormat);
        // if (isLoginSourceEMT(lgnSrc)) {
        //   goBack();
        // }
    };
    const submitEmailDownload = (email, download) => {
        if (locationState.dwnldtransactionType) {
            download.transactionType = locationState.dwnldtransactionType;
            download.scripIdentifier = scripIdentifier;
            download.accountId = accCode;
            di.pnlReport.downloadTransactionReport(download);
        }
    };
    useEffect(() => {
        if ((emailStatus && (emailStatus === null || emailStatus === void 0 ? void 0 : emailStatus.isOpen) !== null) ||
            (downloadStatus &&
                (downloadStatus === null || downloadStatus === void 0 ? void 0 : downloadStatus.isOpen) !== null &&
                props.showLoader &&
                (emailCheck || downloadCheck))) {
            closeDrawerLoader();
            if ((emailCheck && (emailStatus === null || emailStatus === void 0 ? void 0 : emailStatus.isOpen) === true) ||
                (downloadCheck && (downloadStatus === null || downloadStatus === void 0 ? void 0 : downloadStatus.isOpen) === true)) {
                openDrawerDownloadS();
            }
            else {
                openDrawerFail();
            }
        }
        else {
            props.setDownloadSuccess(false);
            props.setDownloadFail(false);
        }
    }, [emailStatus === null || emailStatus === void 0 ? void 0 : emailStatus.isOpen, downloadStatus === null || downloadStatus === void 0 ? void 0 : downloadStatus.isOpen]);
    useEffect(() => {
        if (PDF_or_Excel && (emailCheck || downloadCheck)) {
            if (emailCheck && emailList.length > 0) {
                setSubmitDisabled(true);
            }
            else if (downloadCheck && emailCheck && emailList.length > 0) {
                setSubmitDisabled(true);
            }
            else if (downloadCheck && !emailCheck) {
                setSubmitDisabled(true);
            }
            else {
                setSubmitDisabled(false);
            }
        }
        else {
            setSubmitDisabled(false);
        }
    }, [emailCheck, emailList, downloadCheck, PDF_or_Excel]);
    const setUrl = () => {
        const assetTypeObj = Object.entries(assetTypeMappingObj);
        let appendAssetType;
        assetTypeObj.map((assetRecord) => {
            var _a;
            if (((_a = assetRecord[1]) === null || _a === void 0 ? void 0 : _a.assetType) === assetType) {
                appendAssetType = assetRecord[0];
            }
        });
        let foundTab;
        TabMapping.map((tabRecord) => {
            var _a;
            if ((tabRecord === null || tabRecord === void 0 ? void 0 : tabRecord.assetType) && ((_a = tabRecord.assetType) === null || _a === void 0 ? void 0 : _a.length) > 1)
                tabRecord.assetType.map((assetRecord) => {
                    if (assetRecord === assetType)
                        foundTab = tabRecord;
                });
            else if ((tabRecord === null || tabRecord === void 0 ? void 0 : tabRecord.assetType) && tabRecord.assetType[0] === assetType) {
                foundTab = tabRecord;
            }
        });
        const destination = ".." +
            getLoginSourceURL(loginOrigin) +
            "?reportName=ProfitandLoss" +
            "&tab=" +
            (foundTab === null || foundTab === void 0 ? void 0 : foundTab.tabEventKey) +
            "&assetType=" +
            appendAssetType +
            "&fromDate=" +
            moment(new Date(fromDate)).format("yyyy-MM-DD") +
            "&toDate=" +
            moment(new Date(toDate)).format("yyyy-MM-DD");
        return destination;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "customForm mobForm mobForm-new pnl-download" },
            React.createElement("form", { className: "customFormSection", onSubmit: (e) => handleSubmit(e), onKeyDown: (e) => {
                    if (e.key === "Enter") {
                        if (!currEmailvalue && submitDisabled) {
                            handleSubmit(e);
                        }
                    }
                } },
                React.createElement(Link, { to: setUrl() },
                    React.createElement("div", { className: "d-flex align-items-center mobFormHead" },
                        React.createElement("i", { className: "edel-icon-arrow-left1" }),
                        React.createElement("h1", null, "Download Profit & Loss Report"))),
                React.createElement("div", null,
                    React.createElement("div", { className: "mobFormWrap mobFormWrap-new" },
                        React.createElement("div", { className: "customFormSection_field dateWrap" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-md-12 col-lg-12" },
                                    React.createElement("div", { className: "date-labels" },
                                        React.createElement("div", null,
                                            React.createElement("label", { htmlFor: "date", className: "form-label" }, "From Date")),
                                        React.createElement("div", null,
                                            React.createElement("label", { htmlFor: "date", className: "form-label" }, "To Date"))),
                                    React.createElement("div", { className: "input-group input-group-dp" },
                                        React.createElement("div", { className: "input-group-date-section" },
                                            React.createElement("div", null,
                                                React.createElement("span", { className: "d-flex date-partition" },
                                                    React.createElement("input", { type: "text", className: "form-control", placeholder: "dd-mm-yy", value: moment(startDate).format("DD-MMM-YY") }),
                                                    React.createElement("a", { className: "input-group-append input-group-append-dp", onClick: startDatePicker },
                                                        React.createElement("span", { className: "input-group-text d-block" },
                                                            React.createElement("i", { className: "edel-icon-calendar-report" }))))),
                                            React.createElement("div", null,
                                                React.createElement("span", { className: "d-flex date-partition" },
                                                    React.createElement("input", { type: "text", className: "form-control", placeholder: "dd-mm-yy", value: moment(endDate).format("DD-MMM-YY") }),
                                                    React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: closeDrawerDate, isVisible: isVisibleStart, className: "drawer__handle-wrapper backgroundcolor_bluedrawer" },
                                                        React.createElement("div", null,
                                                            React.createElement("div", { className: "drawer-container" },
                                                                React.createElement("div", { className: "date-container" },
                                                                    React.createElement("label", { className: "select-date" }, "Select From Date"),
                                                                    React.createElement("input", { type: "text", className: "form-control", placeholder: "dd-mm-yy", value: moment(startDate).format("DD-MMM-YY") }))),
                                                            React.createElement(DatePicker, { placeholderText: "dd-mm-yy", dateFormat: "d-MMM-yy", onChange: (date) => setStartDate(date), ref: _startcalendar, inline: true, formatWeekDay: (nameOfDay) => nameOfDay.slice(0, 1), minDate: pnlDownloadDate, maxDate: previousDay, scrollableYearDropdown: true }),
                                                            React.createElement("a", { className: "btn btn-primary custom_btn custom_btn-new", type: "submit", onClick: () => setIsVisibleStart(false) }, "Apply"))),
                                                    React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: closeDrawerDate, isVisible: isVisibleEnd, className: "drawer__handle-wrapper backgroundcolor_bluedrawer" },
                                                        React.createElement("div", null,
                                                            React.createElement("div", { className: "drawer-container" },
                                                                React.createElement("div", { className: "date-container" },
                                                                    React.createElement("label", { className: "select-date" }, "Select To Date"),
                                                                    React.createElement("input", { type: "text", className: "form-control", placeholder: "dd-mm-yy", value: moment(endDate).format("DD-MMM-yy") }))),
                                                            React.createElement(DatePicker, { placeholderText: "dd-mm-yy", dateFormat: "d-MMM-yy", onChange: (date) => setEndDate(date), ref: _endcalendar, inline: true, formatWeekDay: (nameOfDay) => nameOfDay.slice(0, 1), minDate: startDate, maxDate: previousDay, scrollableYearDropdown: true }),
                                                            React.createElement("a", { className: "btn btn-primary custom_btn custom_btn-new ", type: "submit", onClick: () => setIsVisibleEnd(false) }, "Apply"))),
                                                    React.createElement("a", { className: "input-group-append input-group-append-dp", onClick: endDatePicker },
                                                        React.createElement("span", { className: "input-group-text d-block" },
                                                            React.createElement("i", { className: "edel-icon-calendar-report" })))))))))),
                        React.createElement("div", { className: "customFormSection_field radioField" },
                            React.createElement("label", { htmlFor: "", className: "form-label" }, "Report Format"),
                            React.createElement("div", { className: "radio report-format" },
                                React.createElement("div", { className: "form-check" },
                                    React.createElement("input", { className: "form-check-input", type: "radio", name: "reportType", onChange: (e) => setPDForExcel(ReportType.PDF) }),
                                    React.createElement("label", { className: "form-check-label", htmlFor: "flexRadioDefault1" }, "PDF")),
                                React.createElement("div", { className: "form-check" },
                                    React.createElement("input", { className: "form-check-input", type: "radio", 
                                        // disabled={isImpersonated && lgnSrc !== "nesttrader"}
                                        name: "reportType", onChange: (e) => {
                                            setPDForExcel(ReportType.EXCEL);
                                            isImpersonated && setDownloadCheck(false);
                                        } }),
                                    React.createElement("label", { className: "form-check-label", htmlFor: "flexRadioDefault2" }, "Excel")))),
                        React.createElement("div", { className: "mailCheckbox" },
                            React.createElement("div", { className: "customFormSection_field checkboxWrap" },
                                React.createElement("label", { htmlFor: "", className: "form-label" }, "Get Report As"),
                                React.createElement("div", { className: "checkbox" },
                                    React.createElement("div", { className: "form-check" },
                                        React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", name: "downloadType[]", id: "flexCheckDefault", disabled: (isImpersonated &&
                                                lgnSrc !== "nesttrader" &&
                                                PDF_or_Excel &&
                                                PDF_or_Excel === ReportType.EXCEL) ||
                                                sales_native_app, onChange: (e) => setDownloadCheck(e.target.checked), checked: isImpersonated && PDF_or_Excel === ReportType.EXCEL
                                                ? false
                                                : downloadCheck }),
                                        React.createElement("label", { className: "form-check-label", htmlFor: "flexCheckDefault" }, "Download")),
                                    (locationState === null || locationState === void 0 ? void 0 : locationState.avoidEmail) ? null : (React.createElement("div", { className: "form-check" },
                                        React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", id: "flexCheckChecked", name: "downloadType[]", onChange: (e) => {
                                                //setshowMailInput(e.target.checked);
                                                setEmailCheck(e.target.checked);
                                            }, required: !(downloadCheck || emailCheck) }),
                                        React.createElement("label", { className: "form-check-label", htmlFor: "flexCheckChecked" }, "Email"))))),
                            emailCheck && (React.createElement("div", { className: "customFormSection_field mailWrap" },
                                React.createElement("div", { className: "blue_bg blue_bg-new mail" },
                                    emailList.length > 0 && (React.createElement("div", { className: "mail_label" },
                                        React.createElement("ul", { className: "mail_label_body" }, emailList.map((el, idx) => {
                                            return (React.createElement("li", { key: idx, className: "mail_label_body_item" },
                                                el,
                                                !sales_native_app && (React.createElement("span", { className: "mail_label_close", onClick: () => {
                                                        setEmailList((emailList) => emailList.filter((_, i) => emailList[i] !== el));
                                                        storeEmailListInSessionStorage(el, sessionEmailList, false);
                                                    } },
                                                    React.createElement("i", { className: "edel-icon-rounded-close" })))));
                                        })))),
                                    !sales_native_app && (React.createElement("div", { className: "mail-input" },
                                        React.createElement("input", { ref: inputRef, type: "text", className: "form-control", pattern: emailRegex.source, value: currEmailvalue, onChange: (e) => {
                                                setCurrEmailValue(e.target.value);
                                                e.target.setCustomValidity("");
                                                inputRef.current.checkValidity();
                                            }, disabled: isImpersonated || lgnSrc === "nesttrader", placeholder: "Enter email address", required: emailCheck && emailList.length === 0, onInvalid: (e) => {
                                                if (e.currentTarget.validity.valueMissing) {
                                                    return e.currentTarget.setCustomValidity(enterMail);
                                                }
                                                if (e.currentTarget.validity.patternMismatch) {
                                                    return e.currentTarget.setCustomValidity(validMail);
                                                }
                                            }, onKeyDown: (e) => {
                                                if (e.key === "Enter" &&
                                                    !isImpersonated &&
                                                    lgnSrc !== "nesttrader") {
                                                    e.preventDefault();
                                                    EmailListUpdate();
                                                    if (inputRef && inputRef.current) {
                                                        inputRef.current.checkValidity();
                                                        inputRef.current.reportValidity();
                                                    }
                                                }
                                            } }),
                                        React.createElement("div", { className: `icon ${(isImpersonated || lgnSrc == "nesttrader") &&
                                                "pe-none user-select-auto"}` },
                                            React.createElement("i", { className: `edel-icon-add ${(isImpersonated || lgnSrc == "nesttrader") &&
                                                    "pe-none user-select-auto txt_monochromeGrey"}`, onClick: () => {
                                                    if (!isImpersonated &&
                                                        lgnSrc !== "nesttrader") {
                                                        EmailListUpdate();
                                                        if (inputRef && inputRef.current) {
                                                            inputRef.current.checkValidity();
                                                            inputRef.current.reportValidity();
                                                        }
                                                    }
                                                } }))))))))),
                    !isClientLogin && (React.createElement("div", { className: "my-3" },
                        React.createElement(PANPassword, null))),
                    React.createElement("div", null,
                        React.createElement("button", { className: "btn btn-primary custom_btn custom_btn-new", type: "submit", disabled: !submitDisabled }, "Submit")))),
            React.createElement(Drawer, { isVisible: props.showLoader, onClose: closeDrawerLoader, duration: 250, hideScrollbars: true, className: "drawer__handle-wrapper" },
                React.createElement(SmcasePopupLoaderMob, { Title: "Profit & Loss", closeDrawer: closeDrawerLoader, pageName: "Profit & Loss", messageReactNode: React.createElement(React.Fragment, null,
                        React.createElement("label", { className: "update-message" }, "Your request is being processed")) })),
            React.createElement(Drawer, { isVisible: props.downloadSuccess, onClose: closeDrawerDownloadS, duration: 250, hideScrollbars: true, className: "pnl-report-success drawer__handle-wrapper" },
                React.createElement(SmcasePopupSuccessMob, { Title: "Profit & Loss", closeDrawer: closeDrawerDownloadS, operation: props.operation, pageName: "Profit & Loss", sendBack: true, goBack: goBack, messageReactNode: React.createElement(React.Fragment, null,
                        React.createElement("label", { className: "update-message" }, "Your request was successfully processed.")) })),
            React.createElement(Drawer, { isVisible: props.downloadFail, onClose: closeDrawerFail, duration: 250, hideScrollbars: true, className: "drawer__handle-wrapper" },
                React.createElement(SmcasePopupFailMob, { closeDrawer: closeDrawerFail, operation: props.operation, pageName: "Profit & Loss", sendBack: true, goBack: goBack })))));
};
export default DownloadReportPopupMob;
